import { IonIcon, IonImg } from "@ionic/react";
import { close } from "ionicons/icons";
import { useContext, useEffect, useRef, useState } from "react";
import LiveContext from "../../../contexts/live.ctx";
import getSymbolFromCurrency from "../../../helpers/getSymbolFromCurrency";
import BaseButton from "../../@Shared/BaseButton/BaseButton";
import "./LiveTopPanel.css";

interface ContainerProps {}

const LiveTopPanel: React.FC<ContainerProps> = (props) => {
  const liveCtx = useContext(LiveContext);
  const [isActive, setIsActive] = useState(false);
  const [displayedPledgesList, setDisplayedPledgesList] = useState(
    [] as { title: string; logoUrl: string | undefined; totalAmount: number }[]
  );
  const [totalPledgesAmount, setTotalPledgesAmount] = useState(0);

  useEffect(() => {
    const computedPledgeList = [...liveCtx.liveShowProjects]
      .sort((a, b) => a.position - b.position)
      .map(project => ({
        title: project.name,
        logoUrl: project.logoUrl,
        totalAmount: project.totalPledgesAmount / 100,
      }));

    setDisplayedPledgesList(computedPledgeList);

    setTotalPledgesAmount(
      computedPledgeList.reduce((sum, p) => sum + p.totalAmount, 0)
    );
  }, [liveCtx.liveShowProjects, liveCtx.liveProject])

  const panelRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(event.target as Node)) {
        setIsActive(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div
      ref={panelRef}
      className={
        isActive
          ? "live-top-panel live-top-panel--is-active"
          : "live-top-panel live-top-panel--is-unactive"
      }
      data-testid="live-top-panel"
    >
      <div className="live-top-panel__active-display">
        <div className="live-top-panel__active-display__header">
          <span>Mes Promesses</span>
          <span>
            <IonIcon icon={close} onClick={() => setIsActive(false)} />
          </span>
        </div>
        <div className="live-top-panel__active-display__pledges-list">
          {displayedPledgesList.map((projectPledges) => {
            return (
              <div
                className={"live-top-panel__active-display__pledges-list__item"}
                key={projectPledges.title}
              >
                <div
                  className={
                    "live-top-panel__active-display__pledges-list__item__infos"
                  }
                >
                  <div className="live-top-panel__active-display__pledges-list__item__infos__logo">
                    {projectPledges.logoUrl && (
                      <IonImg src={projectPledges.logoUrl} />
                    )}
                  </div>
                  <span>{projectPledges.title}</span>
                </div>
                <div className="live-top-panel__active-display__pledges-list__item__amount">
                  {Math.floor(projectPledges.totalAmount).toLocaleString(
                    undefined,
                    { maximumFractionDigits: 0 }
                  ) +
                    " " +
                    (getSymbolFromCurrency(liveCtx.liveShow.pledgesCurrency) ||
                      "€")}
                </div>
              </div>
            );
          })}
        </div>
        <div className="live-top-panel__active-display__footer">
          <div className="live-top-panel__active-display__footer__pledges-total">
            <span>Total de mes promesses :</span>
            <span>
              {totalPledgesAmount.toLocaleString(undefined, {
                maximumFractionDigits: 0,
              })}{" "}
              {getSymbolFromCurrency(liveCtx.liveShow.pledgesCurrency) || "€"}
            </span>
          </div>
          <div className="live-top-panel__active-display__footer__action">
            <BaseButton
              outline
              tight
              expand
              onClick={() => liveCtx.userQuitHandler()}
            >
              Quitter l'évènement
            </BaseButton>
          </div>
        </div>
      </div>
      <div className="live-top-panel__unactive-display">
        <div
          className="live-top-panel__unactive-display__hamburger"
          onClick={() => setIsActive(true)}
        >
          <div />
          <div />
          <div />
        </div>
        <div className="live-top-panel__unactive-display__user-amount">
          Mes Promesses :{" "}
          {totalPledgesAmount.toLocaleString(undefined, {
            maximumFractionDigits: 0,
          })}{" "}
          {getSymbolFromCurrency(liveCtx.liveShow.pledgesCurrency) || "€"}
        </div>
      </div>
    </div>
  );
};

export default LiveTopPanel;
